import area from "@/assets/js/area.js";
import { l, GetResourceUrl } from "@/assets/js/i18n.js";
import countryList from "@/assets/js/country-data.js";

let baseURL, title;
switch (process.env.NODE_ENV) {
    case "production":
        baseURL = "/";
        var ws = "ws";
        if (location.protocol.indexOf("https") != -1) {
            ws = "wss";
        }
        break;

    default:
        // baseURL = "http://47.99.116.223:48008/";
        // baseURL = "http://47.99.116.223:48007/"; // 测试环境
        // baseURL = "http://47.99.116.223:48017/";
        baseURL = "https://www.chinaduancai.com";

        // baseURL = "https://local.chinaduancai.com/";

        // baseURL = "http://127.0.0.1:8000/";
        // baseURL = "http://en.chinaduancai.com/"; // baseURL = "http://47.99.116.223:48004/";


        break;
}


document.title = l("中锻材-锻材交易_锻件定制_锻造加工_锻件采购_锻材现货_买锻材");

// http://47.99.116.223:48017/    demo页面
// http://47.99.116.223:48018/   local页面


// 48006  pro线上环境
// 48007  dev测试环境
// 48008  http://local.chinaduancai.com/ local开发环境 

const weight_methodList = [
    {
        id: 1,
        name: l("过磅"),
    },
    {
        id: 2,
        name: l("理计"),
    },
];
const characterList = [
    {
        id: 1,
        name: l("正品现货")
    },
    {
        id: 2,
        name: l("二级余料")
    },
    {
        id: 3,
        name: l("正品余料")
    },
];
const have_warrantyList = [
    {
        id: 1,
        name: l("是"),
    },
    {
        id: 0,
        name: l("否"),
    },
];
const have_reportList = [
    {
        id: 1,
        name: l("是"),
    },
    {
        id: 0,
        name: l("否"),
    },
];

const credit_ratingList = [
    {
        id: 0,
        name: l("高风险"),
        tip_title: l("严重警告"),
        tip_content: l("因您的企业多次（3次及以上）恶意报价，已被平台列为高风险对象。您的报价将在客户订单处打上高风险标签。"),
        tip_content_business: l("该供应商因多次（3次及以上）恶意报价，已被平台列为高风险对象。其报价可能包含虚假信息或欺诈行为，请谨慎合作。"),
    },
    {
        id: 1,
        name: l("中风险"),
        tip_title: l("警告"),
        tip_content: l("因您的企业多次（2次及以上）恶意报价，已被平台列为中风险对象。您的报价将在客户订单处打上中风险标签。"),
        tip_content_business: l("该供应商已累计2次恶意报价记录，已被平台列为中风险对象。"),
    },
    {
        id: 2,
        name: l("有风险"),
        tip_title: l("注意"),
        tip_content: l("因您的企业历史记录中存在1次恶意报价行为价，已被平台列为有风险对象。您的报价将在客户订单处打上有风险标签。"),
        tip_content_business: l("该供应商历史记录中存在1次恶意报价行为，已被平台标记为有风险。"),
    },
    {
        id: 3,
        name: l("普通"),
    },
    {
        id: 4,
        name: l("良好"),
    },
    {
        id: 5,
        name: l("优质"),
    },
];

const forge_typeList = [
    {
        id: 1,
        name: l("自由锻")
    },
    {
        id: 2,
        name: l("模锻")
    },
    {
        id: 3,
        name: l("快锻")
    },
    {
        id: 4,
        name: l("碾环")
    }
];

const machining_typeList = [
    {
        id: 1,
        name: l("粗加工")
    },
    {
        id: 2,
        name: l("半精加工")
    },
    {
        id: 3,
        name: l("精加工")
    },
    {
        id: 4,
        name: l("超精加工")
    }
];

export default {
    baseURL,
    title,
    characterList,
    weight_methodList,
    have_warrantyList,
    have_reportList,
    areaList: area.areaList,
    cityList: area.cityList,
    credit_ratingList,
    forge_typeList,
    countryList,
    machining_typeList
};
